export const staticLabelsCompare = {
  en: {
    compareProducts: "Compare Products",
    back: "Back",
    clearResults: "Clear Results",
    compare: "Compare",
  },
  th: {
    compareProducts: "เปรียบเทียบผลิตภัณฑ์",
    back: "ย้อนกลับ",
    clearResults: "ล้างผลลัพธ์",
    compare: "ล้างผลลัพธ์",
  },
};
